import * as React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import { trackFiltersChange } from './analytics';
import {
  getOffersHistory,
  openOfferFromHistory,
  setPage,
  setTypeFilter,
  setDefaultRooms,
  setDefaultStatus,
} from '../../../actions/offersHistory';
import { selectActiveTypeFilter, selectLocationFilters } from '../../../selectors/offersHistory';
import { ETypeFilterValues } from '../../../types/offerHistory';
import { Filter } from '../../../components/OffersHistory/Desktop';
import { TThunkDispatch } from '../../../types/redux';

export const TypeFilterContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const activeValue = useSelector(selectActiveTypeFilter);
  const filterOptions = useSelector(selectLocationFilters);

  const handleChangeValue = React.useCallback(
    async (_: React.ChangeEvent, value: ETypeFilterValues) => {
      batch(() => {
        dispatch(setTypeFilter(value));
        dispatch(setDefaultRooms());
        dispatch(setDefaultStatus());
        dispatch(setPage(1));
      });

      await dispatch(getOffersHistory(false));
      dispatch(trackFiltersChange());
      await dispatch(openOfferFromHistory());
    },
    [dispatch],
  );

  if (!filterOptions) {
    return null;
  }

  return (
    <Filter
      title="Расположение"
      spliced={false}
      options={filterOptions}
      value={activeValue}
      onChange={handleChangeValue}
    />
  );
};
